// import React from 'react'
// import styled from 'styled-components'
// import Timeline from '@mui/lab/Timeline';
// import TimelineItem from '@mui/lab/TimelineItem';
// import TimelineSeparator from '@mui/lab/TimelineSeparator';
// import TimelineConnector from '@mui/lab/TimelineConnector';
// import TimelineContent from '@mui/lab/TimelineContent';
// import TimelineDot from '@mui/lab/TimelineDot';
// import { experiences } from '../../data/constants';
// import ExperienceCard from '../Cards/ExperienceCard';

// const Container = styled.div`
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     position: relative;
//     z-index: 1;
//     align-items: center;
//     padding: 0px 0px 60px 0px;
//     @media (max-width: 960px) {
//         padding: 0px;
//     }
// `;

// const Wrapper = styled.div`
//     position: relative;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     flex-direction: column;
//     width: 100%;
//     max-width: 1350px;
//     padding: 40px 0px 0px 0px;
//     gap: 12px;
//     @media (max-width: 960px) {
//         flex-direction: column;
//     }
// `;

// const Title = styled.div`
// font-size: 42px;
// text-align: center;
// font-weight: 600;
// margin-top: 20px;
//   color: ${({ theme }) => theme.text_primary};
//   @media (max-width: 768px) {
//       margin-top: 12px;
//       font-size: 32px;
//   }
// `;

// const Desc = styled.div`
//     font-size: 18px;
//     text-align: center;
//     max-width: 600px;
//     color: ${({ theme }) => theme.text_secondary};
//     @media (max-width: 768px) {
//         margin-top: 12px;
//         font-size: 16px;
//     }
// `;

// const TimelineSection = styled.div`
//     width: 100%;
//     max-width: 1000px;
//     margin-top: 10px;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     gap: 12px;
//     @media (max-width: 660px) {
//         align-items: end;
//     }
// `;

// const Experience = () => {
//     return (
//         <Container id="experience">
//             <Wrapper>
//                 <Title>Work Experience</Title>
//                 <Desc>
//                     These are my professional experiences in the field of software development.
//                 </Desc>
//                 <TimelineSection>
//                     <Timeline position="alternate">
//                         {experiences.map((experience, index) => (
//                             <TimelineItem key={index}>
//                                 <TimelineSeparator>
//                                     <TimelineDot variant="outlined" color="secondary" />
//                                     {index !== experiences.length - 1 && (
//                                         <TimelineConnector style={{ background: '#854CE6' }} />
//                                     )}
//                                 </TimelineSeparator>
//                                 <TimelineContent
//                                     sx={{
//                                         py: '12px',
//                                         px: 2,
//                                         textAlign: index % 2 === 0 ? 'left' : 'right', // Alternating text alignment
//                                         alignSelf: index % 2 === 0 ? 'flex-start' : 'flex-end' // Align based on index
//                                     }}
//                                 >
//                                     <ExperienceCard experience={experience} />
//                                 </TimelineContent>
//                             </TimelineItem>
//                         ))}
//                     </Timeline>
//                 </TimelineSection>
//             </Wrapper>
//         </Container>
//     );
// };

// export default Experience;

import React from 'react';
import styled from 'styled-components';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { experiences } from '../../data/constants';
import ExperienceCard from '../Cards/ExperienceCard';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    margin-bottom: 10px;
    padding: 0px 0px 60px 0px;
    @media (max-width: 960px) {
        padding: 0px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 40px 0px 0px 0px;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

const Title = styled.div`
    font-size: 42px;
    text-align: center;
    font-weight: 600;
    margin-top: 20px;
    color: ${({ theme }) => theme.text_primary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 32px;
    }
`;

const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    // max-width: 600px;
    padding:20px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
        width:100%;
    }
`;

const TimelineSection = styled.div`
    width: 100%;
    max-width: 1000px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;

    @media (max-width: 960px) {
   width:100%;
        // flex-direction: row;
        // align-items: flex-start;
        // justify-content: flex-start;
    }
`;

const TimelineWrapper = styled.div`
    width: 100%;
    max-width: 900px;
    // display:none;

    @media (max-width: 960px) {
        // max-width: 900px;
        width:100%;
    }
`;

const ContentWrapper = styled.div`
    width: 100%;
    max-width: 500px;
    display: none;
    flex-direction: column;
    align-items: flex-start;


    @media (max-width: 960px) {
        width:100%;
        display: flex;
        max-width: calc(100vw - 40px); /* Adjust as needed */
    }
`;

const Experience = () => {
    return (
        <Container id="experience">
            <Wrapper>
                <Title>Work Experience</Title>
                <Desc>
                    These are my professional experiences in the field of software development.
                </Desc>
                <TimelineSection>
                    <TimelineWrapper>
                        <Timeline position="alternate">
                            {experiences.map((experience, index) => (
                                <TimelineItem key={index} sx={{ display: { xs: 'none', sm: 'flex' } }}>
                                    <TimelineSeparator sx={{
                                        display: { xs: 'none', sm: 'flex' }, // Hide on mobile (xs) and show on small screens and up
                                    }}>
                                        <TimelineDot variant="outlined" color="secondary" />
                                        {index !== experiences.length - 1 && (
                                            <TimelineConnector style={{ background: '#854CE6' }} />
                                        )}
                                    </TimelineSeparator>
                                    <TimelineContent
                                        sx={{
                                            display: { xs: 'none', sm: 'flex' },
                                            py: '12px',
                                            px: 2,
                                            textAlign: index % 2 === 0 ? 'left' : 'right', // Alternating text alignment
                                            alignSelf: index % 2 === 0 ? 'flex-start' : 'flex-end' // Align based on index
                                        }}
                                    >
                                        <ExperienceCard experience={experience} />
                                    </TimelineContent>
                                </TimelineItem>
                            ))}

                        </Timeline>
                    </TimelineWrapper>
                    <ContentWrapper
                    // sx={{
                    //     display: { xs: 'flex', sm: 'none' }
                    // }}
                    >
                        {experiences.map((experience, index) => (<ExperienceCard experience={experience}
                        // sx={{
                        //     display: { xs: 'flex', sm: 'none' }
                        // }} 
                        />))}
                        {/* Timeline content is now shown to the right side on mobile */}
                        {/* Move the timeline content display to the right in mobile view */}
                    </ContentWrapper>
                </TimelineSection>
            </Wrapper>
        </Container >
    );
};

export default Experience;
